import React, { useState } from "react";

import Hero from "../../components/Hero/Hero";

import toast from "../../components/ui/toast";
import FormLocalSearch from "../../components/FormLocalSearch/FormLocalSearch";
import ResultLocalSearch from "../../components/ResultLocalSearch/ResultLocalSearch";
// import { LoaderDots } from "@thumbtack/thumbprint-react";

import Seo from "../../i18n/Seo";
import useLang from "../../i18n/useLang";
import content from "./content";
import "./SearchLocationCheck.css";
import PageFooter from "../../components/PageFooter/PageFooter";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/tech/";

const SearchLocationCheck = () => {
  const lang = useLang();
  const t = content[lang];
  const [displayFormSearch, setDisplaySearch] = useState(true);
  const [displaySearchLinks, setDisplaySearchLinks] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [paramResults, setParamResults] = useState({});
  const [modalBusinessInfo, setModalBusinessInfo] = useState(false);

  const handleOpenModalBusinessInfo = (businessAddress) => {
    setModalBusinessInfo(true);
  };

  const onLocalSearchSubmit = async (LocalSearch, data) => {
    setIsLoading(true);
    setDisplaySearch(false);

    fetch(`${API_URL}get-uule?`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        location: LocalSearch.location,
        term: LocalSearch.searchTerm,
        user: data,
      }),
    })
      // We get the API response and receive data in JSON format...
      .then((response) => response.json())
      // ...then we update the users state
      .then(async (uule) => {
        let paramLinks = {
          SearchTerm: LocalSearch.searchTerm,
          SearchType: LocalSearch.searchType,
          Location: LocalSearch.location,
          Country: LocalSearch.country,
          Uule: uule,
        };
        setParamResults(paramLinks);
        setIsLoading(false);
        setDisplaySearchLinks(true);
      });
  };

  return (
    <div style={{ padding: "0px 0px 30px 0px" }}>
      <Seo
        routeId="localSerpChecker"
        title={t.seo.title}
        description={t.seo.description}
      />
      <Hero
        title={t.hero.title}
        subtitle={t.hero.subtitle}
        ctaText={t.hero.cta}
        ctaOnClick={() =>
          document
            .querySelector(".serp-form")
            ?.scrollIntoView({ behavior: "smooth", block: "center" })
        }
      />
      {displayFormSearch ? (
        <FormLocalSearch onLocalSearchSubmit={onLocalSearchSubmit} />
      ) : (
        ""
      )}
      {isLoading ? (
        <div className="loading-message-serp">
          <span style={{ display: "inline-block" }}>
            {t.loading}
            <span style={{ fontSize: "20px", marginLeft: "20px" }}>⏳</span>
          </span>
        </div>
      ) : (
        ""
      )}
      {displaySearchLinks ? (
        <>
          <ResultLocalSearch paramLinks={paramResults} />
        </>
      ) : (
        ""
      )}
      {t.guide && (
        <section className="serp-guide">
          {t.guide.sections.map((section) => (
            <div key={section.title} className="serp-guide__section">
              <h2>{section.title}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          ))}
          <div className="serp-guide__section">
            <h2>{t.guide.faqTitle}</h2>
            <div className="serp-guide__faq">
              {t.guide.faq.map((item) => (
                <div key={item.question} className="serp-guide__faq-item">
                  <h3>{item.question}</h3>
                  <p>{item.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      <PageFooter />
    </div>
  );
};

export default SearchLocationCheck;
